// extracted by mini-css-extract-plugin
export default {"container":"brand-logo-header_container__1wC0e"};